import { Injectable } from '@angular/core';

export interface IGoogleDirectionData {
  request: any;
  responce: any;
}

@Injectable({
  providedIn: 'root'
})
export class GoogleCacheManagerService {

  private readonly geocodeStore: Array<any> = [];

  private catchData: Array<IGoogleDirectionData> = [];

  constructor() { }

  public validateGeoCodeByLatLng() {

  }

  public validateGeocodeByAddress() {

  }

  public validateDirectionRequest(data: IGoogleDirectionData): IGoogleDirectionData {
    const requestStr: string = JSON.stringify(data.request);

    const found: Array<IGoogleDirectionData> = this.catchData.filter( (item: IGoogleDirectionData) => {
      return ( JSON.stringify(item.request) == requestStr);
    });

    if (data.responce && !found.length) {
      this.catchData.push({request: data.request, responce: data.responce});
    } else if (found.length) {
      return found[0];
    }

    return null;
  }

}
